export default __webpack_public_path__ + "static/media/BadPotion.1120fde1.svg";